export default __webpack_public_path__ + "static/media/chevron_right-black-24dp.75890062.svg";